/**
 * Bilan mensuel : relit ce que le cron du 1er a calculé (BilanMensuelService),
 * feuilletable mois par mois comme dans l'app.
 */
import React, { useEffect, useState } from 'react';

function h() { return { Authorization: `Bearer ${localStorage.getItem('authToken') || ''}` }; }

interface Bilan {
  mois: string;
  synthese: string | null;
  rdv_suivis: number;
  rdv_dossiers_signales: number;
  prospects_nouveaux: number;
  avis_recus: number;
  avis_publies: number;
  fiche_corrections: number;
  concurrents_nouveaux: number;
}

const TUILES: Array<[keyof Bilan, string]> = [
  ['rdv_suivis', 'Rendez-vous suivis'],
  ['rdv_dossiers_signales', 'Dossiers photo signalés'],
  ['prospects_nouveaux', 'Nouveaux prospects'],
  ['avis_recus', 'Avis Google reçus'],
  ['avis_publies', 'Avis 5★ mis en avant'],
  ['fiche_corrections', 'Corrections fiche Google'],
  ['concurrents_nouveaux', 'Nouveaux concurrents repérés'],
];

function moisLisible(mois: string) {
  const d = new Date(mois.length === 7 ? `${mois}-01` : mois);
  return isNaN(d.getTime()) ? mois : d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
}

export default function BilanPage() {
  const [bilans, setBilans] = useState<Bilan[]>([]);
  const [index, setIndex] = useState(0);
  const [etat, setEtat] = useState<'chargement' | 'pret' | 'erreur'>('chargement');

  useEffect(() => {
    fetch('/api/bilan/historique', { headers: h() })
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(d => { setBilans(d.bilans || []); setEtat('pret'); })
      .catch(() => setEtat('erreur'));
  }, []);

  if (etat === 'chargement') return <p className="text-sm text-gray-500">Chargement…</p>;
  if (etat === 'erreur') return <p className="text-sm text-gray-500">Chargement impossible.</p>;
  if (bilans.length === 0) {
    return (
      <div className="max-w-2xl mx-auto bg-white rounded-xl border border-gray-100 p-8 text-center">
        <p className="font-semibold text-gray-900">Votre premier bilan arrive bientôt</p>
        <p className="text-sm text-gray-500 mt-1">Il est préparé le 1er de chaque mois.</p>
      </div>
    );
  }

  const bilan = bilans[index];
  return (
    <div className="max-w-2xl mx-auto space-y-4">
      <div className="flex items-center justify-between">
        <button disabled={index >= bilans.length - 1} onClick={() => setIndex(index + 1)} aria-label="Mois précédent" className="px-3 py-1 rounded-lg border border-gray-200 bg-white disabled:opacity-40">‹</button>
        <p className="font-semibold text-gray-900 first-letter:uppercase">{moisLisible(bilan.mois)}</p>
        <button disabled={index === 0} onClick={() => setIndex(index - 1)} aria-label="Mois suivant" className="px-3 py-1 rounded-lg border border-gray-200 bg-white disabled:opacity-40">›</button>
      </div>

      <div className="bg-white rounded-xl border border-gray-100 p-4">
        <p className="text-sm font-semibold text-gray-900 mb-1">Ce que nous avons fait pour vous</p>
        <p className="text-sm text-gray-600 whitespace-pre-line">{bilan.synthese?.trim() || 'Bilan en cours de préparation.'}</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {TUILES.map(([cle, label]) => (
          <div key={cle} className="bg-white rounded-xl border border-gray-100 p-4">
            <p className="text-2xl font-bold text-gray-900">{Number(bilan[cle]) || 0}</p>
            <p className="text-xs text-gray-500 mt-1">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
